import React, { Component } from 'react';
import { Container, Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import halogo from './images/HA_logo.png'
import atal from './images/ATAL.png';
import RealTimeClock from "./RealTimeClock";
import click from './shortclick.mp3';   

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
   }

  render() {
      return (
          <header>
              <Navbar className="menustyle">
                  < img src={halogo} alt="halogo" width="40" />
                  < img src={atal} alt="halogo" width="160" style={{ marginLeft: "15px", marginRight: "15px" }} />
                  <NavbarBrand className="text-dark" tag={Link} to="/">信息中心</NavbarBrand>
                  <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                  <Collapse isOpen={!this.state.collapsed} navbar>

                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                              <NavLink tag={Link} onClick={this.playClickSound} className="text-dark" to="/">Home</NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink tag={Link} onClick={this.playClickSound} className="text-dark" to="/map">欣田村</NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink tag={Link} onClick={this.playClickSound} className="text-dark" to="/notification">警報</NavLink>
                          </NavItem>
                          <NavItem>
                              <NavLink tag={Link} onClick={this.playClickSound} className="text-dark" to="/login">登入</NavLink>
                          </NavItem>
                        </ul>

                  </Collapse>
                  <table>
                      <td>
                          <RealTimeClock  />
                      </td>
                  </table>
              </Navbar>
          </header>
      );
  }
}
